import React from "react";
import { Link } from "react-router-dom";
const QuickOrder = () => {
  return (
    <div id="quick-order">
      <div className="row">
        <div className="col text-center">
          <Link to="/digital-assays/assay-batch-upload">
            <img
              src={require("../../digital-assays/assets/images/icons/icon_cart.svg")}
            />
            <h2>Quick Order</h2>
            <div className="lead2">Add Multiple Design ID’s to Cart</div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default QuickOrder;
